
define( 'FORCES_AND_MOTION_BASICS/../nls/sk/forces-and-motion-basics-strings',{
          "none": "Žiadne",
          "force": "Sila",
          "values": "Veľkosť",
          "frictionTitle": "Trenie",
          "redWins": "Červení zvíťazili!",
          "frictionForce": "Trecia sila",
          "pause": "Stop",
          "friction": "Trenie",
          "accelerationLab": "Zmena rýchlosti",
          "forces-and-motion-basics.name": "Sila a pohyb: Základný kurz",
          "appliedForce": "Pôsobiaca sila",
          "leftForce": "Sila vľavo",
          "massDisplay.pattern": "{0} kg",
          "rightForce": "Sila vpravo",
          "acceleration": "Zrýchlenie",
          "sound": "Zvuk",
          "lots": "Veľké",
          "forces": "Sily",
          "motion": "Pohyb",
          "tugOfWar": "Preťahovanie lanom",
          "go": "Štart!",
          "newtons.n": "N (Newton)",
          "sumOfForcesEqualsZero": "Výsledná sila = 0 N",
          "blueWins": "Modrí zvíťazili!",
          "speed": "Rýchlosť",
          "sumOfForces": "Výsledná sila",
          "return": "Odznova",
          "translation.credits": "RNDr. Ľubomír Červený<br>http://www.cerveny.sk",
          "newtons": "N (Newton)",
          "masses": "Hmotnosť",
          "forceReadout.pattern": "{0}N"
        } );